import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { PayrollPeriodIdSelectFilter } from "../selects/PayrollPeriodIdSelectFilter";
import { PayTypeIdSelect } from "../selects/PayTypeIdSelect";

export function DeleteAllForm({
	isOpen,
	onClose,
	payrollPeriodId,
	payTypeId,
	setPayrollPeriodId,
	setPayTypeId,
	handleDelete,
}) {
	const [errorState, setErrorState] = useState(false);

	const submit = (e) => {
		if (!payrollPeriodId || !payTypeId) {
			setErrorState(true);
			return;
		}
		handleClose();
		handleDelete(e);
		setErrorState(false);
	};

	const handleClose = () => {
		onClose();
		setPayrollPeriodId("");
		setPayTypeId("");
		setErrorState(false);
	};

	return (
		<>
			<div className={`modal-overlay ${isOpen ? "open" : ""}`}>
				{isOpen && (
					<div className="modal">
						<div className="popUp-header row">
							<div className="popUp-title">
								<h3 style={{ color: "#668fca" }}>Delete!</h3>
							</div>
							<div className="popUp-close">
								<CloseIcon onClick={() => handleClose()} />
							</div>
						</div>
						<div
							className="popUp-body"
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
							}}
						>
							<div className="popUp-item info-item column">
								<div className="info-item-label">Payroll Period</div>
								<div className="info-item-input">
									<PayrollPeriodIdSelectFilter
										payrollPeriodId={payrollPeriodId}
										setPayrollPeriodId={setPayrollPeriodId}
									/>
								</div>
								<span
									style={{
										visibility:
											!payrollPeriodId && errorState ? "visible" : "hidden",
										color: "#ff6565",
										fontSize: "12px",
									}}
								>
									Please fill up this field
								</span>
							</div>
							<div className="popUp-item info-item column">
								<div className="info-item-label">Pay Type</div>
								<div className="info-item-input">
									<PayTypeIdSelect
										payTypeId={payTypeId}
										setPayTypeId={setPayTypeId}
									/>
								</div>
								<span
									style={{
										visibility: !payTypeId && errorState ? "visible" : "hidden",
										color: "#ff6565",
										fontSize: "12px",
									}}
								>
									Please fill up this field
								</span>
							</div>
						</div>
						<div
							className="buttons row"
							style={{
								justifyContent: "center",
								padding: "40px 40px 20px 40px",
							}}
						>
							<button
								id="add-family"
								className="save row"
								onClick={(e) => submit(e)}
								style={{ marginRight: "5px" }}
							>
								DELETE
							</button>
							<button
								id="add-family"
								className="cancel row"
								onClick={() => handleClose()}
							>
								CANCEL
							</button>
						</div>
					</div>
				)}
			</div>
		</>
	);
}